<template>
  <div class="column-wrapper">
    <goods-list :sku-list="columnList"></goods-list>
  </div>
</template>
<script>
import goodsList from '../../components/ProductDoubleEach'
export default {
  components: {
    goodsList
  },
  props: {
    columnList: {
      type: Array
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
.column-wrapper {
  // min-height: 100%;
  // padding: 0 0.2rem;
  // background-color: #eee;
}
</style>
